/*
 * @Description:
 * @Autor: pangting
 * @Date: 2023-07-14 19:36:42
 * @LastEditors: pangting
 * @LastEditTime: 2023-07-14 19:36:47
 */
// 工具方法类，与业务无关的辅助函数集合
export class Tools {
  /**
   * 函数防抖，防止函数多次触发
   * @param fn 实际需要执行的函数
   * @param timerout 限制时间
   * @descript 连续点击，只会触发一次
   */
  private static debounceTimer: any = null;
  public static debounce = (fn: Function, timerout: number = 300) => {
    return function (...args: any[]) {
      if (Tools.debounceTimer) {
        clearTimeout(Tools.debounceTimer);
      }
      return new Promise((resolve) => {
        Tools.debounceTimer = setTimeout(async () => {
          console.log("实际触发");
          resolve(await fn(...args));
        }, timerout);
      });
    };
  };

  /**
   * 函数节流，防止函数多次触发
   * @param fn 实际需要执行的函数
   * @param timerout 限制时间
   * @descript 在限制时间内，只触发一次
   */
  private static throttleTimer: any = null;
  public static throttle = (fn: Function, timerout: number = 1000) => {
    return async function (...args: any[]) {
      return new Promise(async (resolve) => {
        if (Tools.throttleTimer) {
          return;
        }
        Tools.throttleTimer = setTimeout(() => {
          clearTimeout(Tools.throttleTimer);
          Tools.throttleTimer = null;
        }, timerout);
        resolve(await fn(...args));
      });
    };
  };

  // 判断是否为Promise
  public static isPromise(p) {
    return p && Object.prototype.toString.call(p) === "[object Promise]";
  }
}
// 自定义指令拖动
export const dragscroll = (el) => {
  el.onmousedown = (ev) => {
    const disX = ev.clientX;
    const disY = ev.clientY; // 需要上下移动可以加
    const originalScrollLeft = el.scrollLeft;
    const originalScrollTop = el.scrollTop; // 需要上下移动可以加
    const originalScrollBehavior = el.style["scroll-behavior"];
    const originalPointerEvents = el.style["pointer-events"];
    el.style["scroll-behavior"] = "auto";
    // 鼠标移动事件是监听的整个document，这样可以使鼠标能够在元素外部移动的时候也能实现拖动
    document.onmousemove = (dv) => {
      dv.preventDefault();
      const distanceX = dv.clientX - disX;
      const distanceY = dv.clientY - disY; // 需要上下移动可以加
      el.scrollTo(
        originalScrollLeft - distanceX,
        originalScrollTop - distanceY
      ); // 需要上下移动和左右移动
      // el.scrollTo(originalScrollLeft - distanceX, 0); // 不需要上下拖拽，y轴值为0
    };
    document.onmouseup = () => {
      document.onmousemove = null;
      document.onmouseup = null;
      el.style["scroll-behavior"] = originalScrollBehavior;
      el.style["pointer-events"] = originalPointerEvents;
    };
  };
};
